export default {"src":"/_next/static/media/Kordan.77c71c40.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};